interface ArrowRightIconProps {
  size?: number;
  className?: string;
}

export function ArrowRightIcon({ size = 16, className }: ArrowRightIconProps) {
  return (
    <svg
      width={size * (9.15855 / 16)}
      height={size}
      viewBox="0 0 9.15855 16"
      fill="none"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.314423 15.6867C0.732223 16.1044 1.40582 16.1044 1.82362 15.6867L8.90915 8.60112C9.24168 8.26858 9.24168 7.73141 8.90915 7.39888L1.82362 0.313349C1.40582 -0.10445 0.732223 -0.10445 0.314423 0.313349C-0.103376 0.731148 -0.103376 1.40474 0.314423 1.82254L6.48762 8.00426L0.305897 14.186C-0.103376 14.5953 -0.103376 15.2774 0.314423 15.6867Z"
        fill="currentColor"
      />
    </svg>
  );
}
